export const DetailType = {
    DETAIL: 1,
    BANNER: 2,
}